import type { AppInfo } from '~/types'

// APP INFO
export const APP_INFO: AppInfo = {
  name: 'Multiplai Interviews',
  shortName: 'Multiplai Interviews AI',
  description: 'Multiplai Interviews AI is a platform for conducting AI-powered interviews.',
  ogImageLink: 'og.png',
}

// STORAGE KEYS
export const STORAGE_KEY_USER_SETTINGS = 'multiplai-user-settings'
export const STORAGE_KEY_ROOM_SETTINGS = 'multiplai-room-settings'
export const STORAGE_KEY_CURRENT_USER_HANDLE = 'multiplai-user-handle'
export const STORAGE_KEY_ORGANIZATIONS = 'multiplai-organizations'

// EVENTS KEY
export const EVENTS_KEY = 'multiplai-events'

// AWS
export const S3_PREFIX_KEY_INTERVIEW_RECORDING = 'interview-recordings'

// FAQS
export * from './faqs'

// RATING
export * from './rating'

// VIRTUAL BACKGROUND
export * from './virtual-background'
